import Label from "gatsby-theme-dettol/src/components/common/Label/Label"

import "./LabelOverride.scss"

export default Label